import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import TourCard from "@/components/tours/TourCard.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { ref } from "vue";
import { reAuthorize } from "@/services/auth/re-auth";
import ParallelEditErrorModal from "@/components/ParallelEditErrorModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TourView',
  setup(__props) {

const order = ref(null);

reAuthorize(store)
  .then((res) => store.dispatch("OrderStore/getTours"))
  .then((res) => {
    order.value = store?.state?.OrderStore?.tours.find(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
  });
const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ParallelEditErrorModal),
    (order.value)
      ? (_openBlock(), _createBlock(TourCard, {
          key: 0,
          order: order.value,
          index: 1,
          activeOrder: 1
        }, null, 8, ["order"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})